export type QuickReplyInsertMode = 'replace-empty-or-append' | 'append-signature';

export interface QuickReply {
  id: 'appointment' | 'contact' | 'signature';
  label: string;
  preview: string;
  body: string;
  insertMode: QuickReplyInsertMode;
}

interface ServiceQuickRepliesContext {
  serviceName?: string | null;
  phoneNumber?: string | null;
}

const cleanText = (value?: string | null): string => String(value || '').trim();

const buildSignature = (serviceName?: string | null): string => {
  const normalizedServiceName = cleanText(serviceName);
  return normalizedServiceName ? `Pozdrawiamy,\n${normalizedServiceName}` : 'Pozdrawiamy';
};

export const getServiceQuickReplies = ({
  serviceName,
  phoneNumber,
}: ServiceQuickRepliesContext): QuickReply[] => {
  const signature = buildSignature(serviceName);
  const normalizedPhoneNumber = cleanText(phoneNumber);

  const replies: QuickReply[] = [
    {
      id: 'signature',
      label: 'Podpis',
      preview: 'Pozdrawiamy...',
      body: signature,
      insertMode: 'append-signature',
    },
  ];

  if (normalizedPhoneNumber) {
    replies.push({
      id: 'contact',
      label: 'Kontakt',
      preview: 'W razie potrzeby prosimy o kontakt...',
      body: `W razie potrzeby prosimy o kontakt: ${normalizedPhoneNumber}.\n${signature}`,
      insertMode: 'replace-empty-or-append',
    });
  }

  replies.push({
    id: 'appointment',
    label: 'Termin',
    preview: 'Potwierdzamy termin...',
    body: `Potwierdzamy termin. Postaramy się być o ustalonej godzinie. W razie opóźnienia damy znać.\n${signature}`,
    insertMode: 'replace-empty-or-append',
  });

  return replies;
};

export const insertQuickReplyIntoDraft = (
  currentDraft: string,
  quickReply: Pick<QuickReply, 'body' | 'insertMode'>
): string => {
  const body = cleanText(quickReply.body);
  if (!body) {
    return currentDraft;
  }

  const draftWithoutTrailingWhitespace = currentDraft.replace(/\s+$/g, '');
  if (!draftWithoutTrailingWhitespace) {
    return body;
  }

  return `${draftWithoutTrailingWhitespace}\n\n${body}`;
};
